export default __webpack_public_path__ + "static/media/Frame.df1ee7f4.png";